import React from 'react'
import useAppFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore, { ManageProjectStoreType } from '../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../stores/manageProject/useManageProjectAction'
import useWebService from '../../../../services/web/useWebService'
const useDisplayUpdater = () => {
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const projectStore = useManageProjectStore()
    const projectAction = useManageProjectAction()
    const webService = useWebService()

    React.useEffect(() => {
        const stepID = appFolderAndTabStore?.tabSelected?.stepID
        const projectID = projectStore?.projectData?.projectID
        const submittedID = projectStore?.projectData?.submittedID

        // const getUpdater = async () => {
        //     if (projectID && submittedID && stepID) {
        //         const res = await webService.getProjectPageUpdater(projectID, submittedID, stepID)
        //         console.log(`res update date>>`, res)
        //         const saveUpdater: ManageProjectStoreType['currentPageUpdater'] = res.result
        //             ? {
        //                   name_th: res.result.name_th,
        //                   name_en: res.result.name_en,
        //                   date: res.result.date,
        //               }
        //             : null
        //         projectAction.setUpdaterPage(saveUpdater)
        //     }
        // }

        // getUpdater()
        if (projectID && submittedID && stepID) {
            getUpdater(submittedID, projectID, stepID)
        }
    }, [projectStore?.projectData?.submittedID, appFolderAndTabStore?.tabSelected?.stepID])

    const getUpdater = async (submittedID: number, projectID: number, stepID: number) => {
        if (projectID && submittedID && stepID) {
            const res = await webService.getProjectPageUpdater(projectID, submittedID, stepID)
            // console.log(`res update date>>`, res)
            const saveUpdater: ManageProjectStoreType['currentPageUpdater'] = res.result
                ? {
                      name_th: res.result.name_th,
                      name_en: res.result.name_en,
                      date: res.result.date,
                  }
                : null
            projectAction.setUpdaterPage(saveUpdater)
        }
    }
    return { getUpdater }
}

export default useDisplayUpdater
